import React from 'react'

import ClickoutWrapper from 'components/ClickoutWrapper'
import CtaButton from 'components/CtaButton'
import Paper from 'components/Paper'
import PricingComponents from 'components/Pricing'
import { useEventContext } from 'context/EventContext'
import isClickOutUrl from 'helpers/isClickOutUrl'
import useViewport from 'hooks/useViewport'

import AttributeList, { ATTRIBUTE_VARIANTS } from '../AttributeList'
import GridContainer from '../GridContainer'
import GridItem from '../GridItem'
import SubSectionTitle from './components/SubSectionTitle'

import classes from './Pricing.module.scss'

/** @type {import("./types").default} */
const Pricing = ({ isCtaFullWidth = false, isCtaTextButton = false, listings }) => {
  const { down, up } = useViewport()
  const { addEvent } = useEventContext({
    engagementComponent: 'product_pricing',
    name: 'engagement_product_pricing',
  })

  return (
    <>
      <div className={classes.overlayContainer}>
        {down('sm') && <SubSectionTitle columns={listings.length} label="Starting from" />}
      </div>
      <GridContainer>
        {listings.map((listing, index) => {
          const { pricing } = listing
          const ctaUrl = listing.cta_urls.detail
          const noCreditCardRequired = pricing.no_credit_card_required || false

          return (
            <GridItem className="Pricing" key={`pricing-content-${listing.id}`}>
              <Paper className={classes.paper} elevation={0}>
                {up('md') && <SubSectionTitle columns={listings.length} label="Starting from" />}
                <div className={classes.pricingDisplay}>
                  <PricingComponents.Display
                    hidePricingModel
                    pricing={pricing}
                    variant={up('md') ? 'large' : 'small'}
                  />
                </div>

                <div className={classes.listContainer}>
                  <AttributeList
                    key={`attribute-list-${listing.id}`}
                    attributes={[
                      {
                        label: 'Free trial available',
                        variant: pricing.categories.find(category => category === 'free-trial')
                          ? ATTRIBUTE_VARIANTS.check
                          : ATTRIBUTE_VARIANTS.uncheck,
                      },
                      {
                        label: 'Credit cardless trial',
                        variant: noCreditCardRequired ? ATTRIBUTE_VARIANTS.check : ATTRIBUTE_VARIANTS.uncheck,
                      },
                      {
                        label: 'Free account',
                        variant: pricing.categories.find(category => category === 'free')
                          ? ATTRIBUTE_VARIANTS.check
                          : ATTRIBUTE_VARIANTS.uncheck,
                      },
                      {
                        label: 'Subscription based',
                        variant: pricing.categories.find(category => category === 'subscription')
                          ? ATTRIBUTE_VARIANTS.check
                          : ATTRIBUTE_VARIANTS.uncheck,
                      },
                    ]}
                    gridIndex={index}
                    gridSize={listings.length}
                  />
                </div>
                <div className={classes.button}>
                  <ClickoutWrapper
                    url={ctaUrl}
                    isClickout={isClickOutUrl(ctaUrl)}
                    className={{ [classes.ctaButtonFullWidth]: isCtaFullWidth }}
                    {...addEvent({
                      engagementDestination: 'go-to_product_details',
                      engagementDetails: 'button_view-app-info',
                      name: 'engagement_product_click',
                    })}
                  >
                    <CtaButton
                      fullWidth={isCtaFullWidth}
                      label={'app info'}
                      shortLabel={'app info'}
                      variant={isCtaTextButton ? 'text' : 'contained'}
                      secondary
                    />
                  </ClickoutWrapper>
                </div>
              </Paper>
            </GridItem>
          )
        })}
      </GridContainer>
    </>
  )
}

export default Pricing
